import React from "react";
import { useClassicSiteAuth } from "../auth";
import CsrfCookieDiagnosticDisplay from "./CsrfCookieDiagnosticDisplay";

/**
 * @param {Object} props
 * @param {boolean} [props.useAuth] - read identity from context instead of props
 * @param {{ displayName: string, email: string|null, username: string|null }|null} [props.identity]
 * @param {object|null} [props.user]
 * @param {object|null} [props.hoodie]
 * @param {boolean} [props.csrfPresent]
 * @param {number|null} [props.lastCheckedAt]
 */
export default function MemberIdentityCard({
  useAuth: fromContext = false,
  identity: identityProp,
  user: userProp,
  hoodie: hoodieProp,
  csrfPresent: csrfProp,
  lastCheckedAt: checkedProp,
}) {
  const auth = useClassicSiteAuth();
  const identity = fromContext ? auth.identity : identityProp;
  const user = fromContext ? auth.user : userProp;
  const hoodie = fromContext ? auth.hoodie : hoodieProp;
  const csrfDiagnostic = fromContext ? auth.csrfDiagnostic : null;
  const lastCheckedAt = fromContext ? auth.lastCheckedAt : checkedProp;

  if (!identity || !user) {
    return null;
  }

  return (
    <section className="cs-identity-card">
      <div className="cs-identity-card__header">
        {hoodie?.gravatarUrl ? (
          <img
            src={hoodie.gravatarUrl}
            alt=""
            className="cs-identity-card__avatar"
            width={48}
            height={48}
          />
        ) : null}
        <div>
          <h2 className="cs-identity-card__name">{identity.displayName}</h2>
          <p className="cs-identity-card__email">{identity.email || "—"}</p>
        </div>
      </div>

      <dl className="cs-detail__dl cs-identity-card__dl">
        <dt>Username</dt>
        <dd>{identity.username || "—"}</dd>
        <dt>User id</dt>
        <dd>{user.id ?? "—"}</dd>
        <dt>Hoodie profile id</dt>
        <dd>{hoodie?.id ?? "—"}</dd>
        <dt>Zip code</dt>
        <dd>{hoodie?.zipCode ?? "—"}</dd>
        <dt>Recommendations</dt>
        <dd>
          {Array.isArray(hoodie?.recommendations)
            ? hoodie.recommendations.length
            : "—"}
        </dd>
        <dt>Last login</dt>
        <dd>
          {user.last_login
            ? new Date(user.last_login).toLocaleString()
            : "—"}
        </dd>
        <dt>Session checked</dt>
        <dd>
          {lastCheckedAt
            ? new Date(lastCheckedAt).toLocaleString()
            : "—"}
        </dd>
        <CsrfCookieDiagnosticDisplay diagnostic={csrfDiagnostic} compact />
      </dl>

      <p className="cs-identity-card__note">
        <code>classic_site.Member</code> fields (is_club_member, is_list_member) are
        not exposed on <code>hoodies/me/</code> — available only via Django admin or
        staff bridge API.
      </p>
    </section>
  );
}
